import { render, staticRenderFns } from "./version-chain.vue?vue&type=template&id=5a8c2700"
import script from "./version-chain.vue?vue&type=script&lang=js"
export * from "./version-chain.vue?vue&type=script&lang=js"
import style0 from "./version-chain.vue?vue&type=style&index=0&id=5a8c2700&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a8c2700')) {
      api.createRecord('5a8c2700', component.options)
    } else {
      api.reload('5a8c2700', component.options)
    }
    module.hot.accept("./version-chain.vue?vue&type=template&id=5a8c2700", function () {
      api.rerender('5a8c2700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/version-list/version-chain.vue"
export default component.exports